import { Icon } from '@shared/ui/icon';
import { IconButton } from '@shared/ui/icon-button';

import { BACK_BAR_HEIGHT_PX } from './back-bar.constant';
import { BACK_BAR_TEXT } from './back-bar.text';

export interface BackBarProps {
  /** 상위가 "<상위 화면> - <현재 화면>" 으로 만들어 넘긴다 */
  title: string;
  onBack(): void;
}

/** 헤더 아래 띠: 상위 화면으로 + "상위 화면 - 현재 화면" 제목(DD-52 화면 트리). 보일지 · 갈 곳은 상위가 정한다 */
export function BackBar({ title, onBack }: BackBarProps) {
  return (
    <nav
      aria-label={BACK_BAR_TEXT.nav}
      style={{ height: BACK_BAR_HEIGHT_PX }}
      className="flex w-full items-center border-b border-border-default bg-bg-surface px-10"
    >
      <div className="flex items-center gap-2-5">
        <IconButton
          aria-label={BACK_BAR_TEXT.back}
          variant="ghost"
          size="sm"
          icon={<Icon name="chevron-left" size="lg" />}
          onClick={onBack}
        />
        <button
          type="button"
          tabIndex={-1}
          onClick={onBack}
          className="cursor-pointer typo-body text-fg-default"
        >
          {title}
        </button>
      </div>
    </nav>
  );
}
